import { schema } from 'normalizr'

// Types
import type { EntityState } from 'types'

export type TierPeriod = {
  id: number
  label: string
  months: number
  price: number
  price_inc_vat: number
  discount_offer_price: number
  discount_offer_price_inc_vat: number
}

export type SubscriptionTier = {
  id: number
  periods: Array<TierPeriod>
  label: string
  description: string
  credits_give_per_month: number
  is_perpetual: boolean
  suggest_upgrade: boolean
  ordering: number
}

export type TierOffer = {
  discount_offer: null | {
    months: number
    percentage: number
  }
  id: number
  tier: SubscriptionTier
  label: string
  description: string
  free_days: number
  free_months: number
  initial_credits: number
  is_default: boolean
}

export type SubscriptionPeriod = {
  id: number
  label: string
  months: number
  price: number
  tier: SubscriptionTier
}

export type Subscription = {
  id: number
  state: 'FREE' | 'TRIAL' | 'ACTIVE' | 'CANCELLED' | 'PENDING_RETRY' | 'TERMINATED'
  tier: SubscriptionTier
  renewal_day_in_month: number
  renewal_period: SubscriptionPeriod
  next_renewal_date: string
  next_renewal_period: SubscriptionPeriod
  renewal_price: number
  renewal_price_inc_vat: number
  credit_count: number
  is_suspended: boolean
  discount: null | {
    percentage: number
    end_date: string
  }
}

export type PaymentState = 'UNPAID' | 'WAITING' | 'PAID' | 'ERROR' | 'PENDING'

export type SubscriptionOrder = {
  id: number
  currency: string
  payment_url: string
  state: PaymentState
  total_amount: number
  subscription: Subscription
  vat_rate: number
  vat_amount: number
}

export type CreditPackOrder = {
  id: number
  currency: string
  payment_url: string
  state: PaymentState
  total_amount: number
  subscription: Subscription
  vat_rate: number
  vat_amount: number
}

export type CreditPackOffer = {
  id: number
  label: string
  credits: number
  price: number
  price_inc_vat: number
  tier: number
}

export type SubscriptionState = {
  [offerId: string]: EntityState<TierOffer>
}

export const subscriptionSchema = new schema.Entity('subscriptions')
const tierOfferSchema = new schema.Entity('tierOffers')
export const tierOfferListSchema = [tierOfferSchema]
const creditPackOfferSchema = new schema.Entity('creditPackOffers')
export const creditPackOfferListSchema = [creditPackOfferSchema]
export const subscriptionOrderSchema = new schema.Entity('subscriptionOrders', {
  subscription: subscriptionSchema,
})
export const subscriptionOrderListSchema = [subscriptionOrderSchema]

export const creditPackOrderSchema = new schema.Entity('creditPackOrders', {
  subscription: subscriptionSchema,
})
